import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import { Box, Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { useHistory } from "react-router";
import AllEventGalleries from "@jumbo/Dashboards/Gallery";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.gallery"} />, isActive: true },
];

const Gallery = () => {
  const history = useHistory();
  return (
    <PageContainer
      heading={<IntlMessages id="pages.gallery" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            marginBottom={"10px"}
          >
            <div>
              <IntlMessages id="pages.gallery.description" />
            </div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => history.push("/createGallery")}
              style={{ marginRight: 14 }}
            >
              ساخت گالری رویداد
            </Button>
          </Box>

          <Divider />
          <div style={{ marginTop: 24 }}>
            <AllEventGalleries />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Gallery;
